import { STACK_MAX } from "./const";

export const post = (url: string, params: any) => {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.timeout = 30000;
    xmlhttp.open("POST", url, true);
    xmlhttp.setRequestHeader("Content-Type", "application/json");
    xmlhttp.send(JSON.stringify(params));
};

export const consoleInfo = (...data: any[]) => {
    console.log("%c [AdFrontTrace INFO]", "background: #52c41a; color: #fff", ...data);
};

export const consoleWarn = (...data: any[]) => {
    console.warn("%c [AdFrontTrace WARN]", "background: #faad14; color: #fff", ...data);
};

export const debounce = (fn: any, delay: number) => {
    let timer: any = null;
    return (...args: any[]) => {
        if (timer !== null) return;
        timer = setTimeout(() => {
            fn(...args);
            timer = null;
        }, delay);
    };
};

export const postBatch = (url: string, stack: Object[]) => {
    if (stack.length > STACK_MAX) {
        // 超过STACK_MAX条就分成几个请求;
        const loopNum = Math.ceil(stack.length / STACK_MAX);
        for (let i = 0; i < loopNum; i++) {
            post(url, stack.splice(0, 5));
        }
    } else {
        post(url, stack);
    }
    stack.length = 0;
};
